<template>
  <div>
    <b-modal
        v-model="modalActive"
        hide-footer
        id="modal-center"
        centered
        size="lg"
        :title="$t('message.Questions')">
      <ValidationObserver ref="observer" class="w-100">
      <b-tabs content-class="mt-3" fill>
        <b-tab title="Uz" active>
              <b-form-group
                  :label="$t('message.Question_uz')"
                  label-for="name-input"
                  invalid-feedback="Name is required"
              >
                <ValidationProvider rules="required" v-slot="{ errors }" :name="$t('message.Question_uz')" class="w-100">
                    <b-form-input
                        id="name-input"
                        v-model="questions.question_uz"
                        required
                    />
                    <span class="text-danger">{{ errors[0] }}</span>
              </ValidationProvider>
              </b-form-group>
          <br />
          <label>{{$t('message.Answers')}}</label>
          <div v-for="(answer, index) in questions.answers" :key="index">
            <b-form-group
                label-for="name-input"
                invalid-feedback="Name is required"
            >
              <div class="d-flex mt-3">
                <b-form-radio v-model="questions.answers[index].is_correct"
                              :name="'answerStatus'" size="lg" class="mt-2 me-2" :value="true"></b-form-radio>
                <ValidationProvider rules="required" v-slot="{ errors }" :name="$t('message.Answeruz')" class="w-100">
                <b-form-input
                    id="name-input"
                    v-model="answer.answer_uz"
                    required
                />
                  <span class="text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
                <b-button
                    size="sm"
                    class="ms-1"
                    variant="outline-danger"
                    @click="removeAnswerInput(index)"
                ><i class='bx bx-trash'></i>
                </b-button>
              </div>
            </b-form-group>
          </div>
          <div class="w-100 d-flex justify-content-end">
            <b-button class="me-2 mt-2" variant="success" @click="increaseAnswerInput">
              <i class='bx bx-plus'></i>
            </b-button>
          </div>
        </b-tab>
        <b-tab title="Ru">
              <b-form-group
                  :label="$t('message.Question_ru')"
                  label-for="name-input"
                  invalid-feedback="Name is required"
              >
                <ValidationProvider rules="required" v-slot="{ errors }" :name="$t('message.Question_ru')" class="w-100">
                <b-form-input
                    id="name-input"
                    v-model="questions.question_ru"
                    required
                />
                  <span class="text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
              </b-form-group>
          <br />
          <label>{{$t('message.Answers')}}</label>
          <div v-for="(answer, index) in questions.answers" :key="index">
            <div class="d-flex mt-3">
<!--              <b-form-radio v-model="questions.answers[index].is_correct" name="answerStatus" size="lg" class="mt-2 me-2"></b-form-radio>-->
              <ValidationProvider rules="required" v-slot="{ errors }" :name="$t('message.AnswerRu')" class="w-100">
              <b-form-input
                  id="name-input"
                  v-model="answer.answer_ru"
                  required
              />
                <span class="text-danger">{{ errors[0] }}</span>
              </ValidationProvider>
              <b-button
                  size="sm"
                  class="ms-1"
                  variant="outline-danger"
                  @click="removeAnswerInput(index)"
              ><i class='bx bx-trash'></i>
              </b-button>
            </div>
          </div>
          <div class="w-100 d-flex justify-content-end">
            <b-button class="me-2 mt-2" variant="success" @click="increaseAnswerInput">
              <i class='bx bx-plus'></i>
            </b-button>
          </div>
        </b-tab>
        <b-tab title="En">
              <b-form-group
                  :label="$t('message.Question_en')"
                  label-for="name-input"
                  invalid-feedback="Name is required"
              >
                <ValidationProvider rules="required" v-slot="{ errors }" :name="$t('message.Question_en')" class="w-100">
                <b-form-input
                    id="name-input"
                    v-model="questions.question_en"
                    required
                />
                  <span class="text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
              </b-form-group>
          <br />
          <label>{{$t('message.Answers')}}</label>
          <div v-for="(answer, index) in questions.answers" :key="index">
            <div class="d-flex mt-3">
<!--              <b-form-radio v-model="questions.answers[index].is_correct" name="answerStatus" size="lg" class="mt-2 me-2"></b-form-radio>-->
              <ValidationProvider rules="required" v-slot="{ errors }" :name="$t('message.Question_en')" class="w-100">
              <b-form-input
                  id="name-input"
                  v-model="answer.answer_en"
                  required
              />
                <span class="text-danger">{{ errors[0] }}</span>
              </ValidationProvider>
              <b-button
                  size="sm"
                  class="ms-1"
                  variant="outline-danger"
                  @click="removeAnswerInput(index)"
              ><i class='bx bx-trash'></i>
              </b-button>
            </div>
          </div>
          <div class="w-100 d-flex justify-content-end">
            <b-button class="me-2 mt-2" variant="success" @click="increaseAnswerInput">
              <i class='bx bx-plus'></i>
            </b-button>
          </div>
        </b-tab>
        <b-tab title="Kr">
              <b-form-group
                  :label="$t('message.Question_kr')"
                  label-for="name-input"
                  invalid-feedback="Name is required"
              >
                <ValidationProvider rules="required" v-slot="{ errors }" :name="$t('message.Question_kr')" class="w-100">
                <b-form-input
                    id="name-input"
                    v-model="questions.question_kr"
                    required
                />
                  <span class="text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
              </b-form-group>
          <br />
          <label>{{$t('message.Answers')}}</label>
          <div v-for="(answer, index) in questions.answers" :key="index">
            <div class="d-flex mt-3">
<!--              <b-form-radio v-model="questions.answers[index].is_correct" name="answerStatus" size="lg" class="mt-2 me-2"></b-form-radio>-->
              <ValidationProvider rules="required" v-slot="{ errors }" :name="$t('message.Question_kr')" class="w-100">
              <b-form-input
                  id="name-input"
                  v-model="answer.answer_kr"
                  required
              />
                <span class="text-danger">{{ errors[0] }}</span>
              </ValidationProvider>
              <b-button
                  size="sm"
                  class="ms-1"
                  variant="outline-danger"
                  @click="removeAnswerInput(index)"
              ><i class='bx bx-trash'></i>
              </b-button>
            </div>
          </div>
          <br />
          <div class="w-100 d-flex justify-content-end">
            <b-button class="me-2 mt-2" variant="success" @click="increaseAnswerInput">
              <i class='bx bx-plus'></i>
            </b-button>
          </div>
        </b-tab>
      </b-tabs>
      </ValidationObserver>
      <div class="mt-3">
        <input type="file" @change="uploadFile" ref="file">
        <img width="300" v-if="questions.photo" :src="$backendHost+questions.photo" alt="">
      </div>
        <div class="d-flex justify-content-end mt-4">
        <b-button
            variant="outline-primary"
            @click="handleClick"
        >{{$t('message.Cancel')}}
        </b-button>
        <b-button
            @click="handleSubmit"
            style="margin-left: 10px"
            variant="primary"
        >{{$t('message.Add')}}
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>

import {addQuestion, editQuestion, showQuestion} from "../../../../../../../api/test_questions";
import { ValidationProvider,ValidationObserver, extend } from 'vee-validate';
import * as rules from 'vee-validate/dist/rules';
import { messages } from 'vee-validate/dist/locale/ru.json';

Object.keys(rules).forEach(rule => {
  extend(rule, {
    ...rules[rule],
    message: messages[rule]
  });
});

export default {
  name: "QuestionModal",
  components:{
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    activeModal: {
      type: Boolean
    },
    id: {
      default: null,
    }
  },
  data(){
    return{
      selected:[],
      questions: {
        parent_id: null,
        question_uz: '',
        question_ru: '',
        question_en: '',
        question_kr: '',
        images:'',
        answers:[
          {
            id:null,
            is_correct:false,
            answer_uz:'',
            answer_ru:'',
            answer_en:'',
            answer_kr:'',
          }
        ],
      },
    }
  },
  computed: {
    modalActive: {
      get() {
        return this.activeModal;
      },
      set(val) {
        if(!val) this.$emit('closeModal')
      }
    }
  },
  methods:{
    handleClick(){
      this.modalActive = false
    },
    uploadFile(e) {
      this.questions.images = e.target.files[0];
    },
    increaseAnswerInput() {
      if(this.questions.answers.length < 4) {
        this.questions.answers.push({
          id:null,
          is_correct:false,
          answer_uz:'',
          answer_ru:'',
          answer_en:'',
          answer_kr:'',
        })
      }
    },
    removeAnswerInput(a) {
      this.questions.answers.splice(a,1);
    },
    fetchQuestion(){
      showQuestion(this.id).then(res => {
        // eslint-disable-next-line no-console
        this.questions = res.data.data
      })
    },
    async handleSubmit() {
      const isValid = await this.$refs.observer.validate();
      // eslint-disable-next-line no-console
      if(isValid) {
        this.questions.parent_id = this.$route.params.id > 0 ? this.$route.params.id : null
        const form = new FormData()
        form.append('id', this.questions.id)
        form.append('question_uz', this.questions.question_uz)
        form.append('question_ru', this.questions.question_ru)
        form.append('question_en', this.questions.question_en)
        form.append('question_kr', this.questions.question_kr)
        form.append('test_id', this.$route.params.id)
        form.append('answers', JSON.stringify(this.questions.answers));
        if(typeof this.questions.images === 'object')
        {
          form.append('photo', this.questions.images)
        }
        if (this.id) {
          form.append('_method', 'put')
          // eslint-disable-next-line no-unused-vars
          editQuestion(form).then(res => {
            this.$emit('closeModal')
          })
        } else {
          if(this.$route.params.length > 0) {
            this.questions.parent_id = this.$route.params.id;
          }
          // eslint-disable-next-line no-unused-vars
          addQuestion(form).then(res => {
            this.$emit('closeModal')
          })
        }
      }
    },
  },
  watch: {
    id:{
      immediate: true,
      handler(val) {
        // eslint-disable-next-line no-console
        console.log(val)
        if(val) {
          this.fetchQuestion()
        }
      }
    }
  }
}
</script>

<style scoped>

</style>
